export default __webpack_public_path__ + "media/images/features/local_delivery/background_edge-c597cc60b9ca443ca9c8697aa011d43a.png";